import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export const customerSites = createRemoteArrayResourceReducer("CUSTOMER_SITES");
